var components
try {
  components = {
    uIcon: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-icon/u-icon" */ "uview-ui/components/u-icon/u-icon.vue"
      )
    },
    "u-Form": function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u--form/u--form" */ "uview-ui/components/u--form/u--form.vue"
      )
    },
    uFormItem: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-form-item/u-form-item" */ "uview-ui/components/u-form-item/u-form-item.vue"
      )
    },
    "u-Input": function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u--input/u--input" */ "uview-ui/components/u--input/u--input.vue"
      )
    },
    "u-Textarea": function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u--textarea/u--textarea" */ "uview-ui/components/u--textarea/u--textarea.vue"
      )
    },
    uButton: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-button/u-button" */ "uview-ui/components/u-button/u-button.vue"
      )
    },
    uDatetimePicker: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-datetime-picker/u-datetime-picker" */ "uview-ui/components/u-datetime-picker/u-datetime-picker.vue"
      )
    },
    uPicker: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-picker/u-picker" */ "uview-ui/components/u-picker/u-picker.vue"
      )
    },
    uModal: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-modal/u-modal" */ "uview-ui/components/u-modal/u-modal.vue"
      )
    },
    uPopup: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-popup/u-popup" */ "uview-ui/components/u-popup/u-popup.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var g0 = _vm.list.length
  var g1 =
    _vm.i === 0 && !_vm.id
      ? _vm.model.memberName && _vm.columns2.length > 0
      : null
  if (!_vm._isMounted) {
    _vm.e0 = function ($event) {
      _vm.show2 = true
    }
    _vm.e1 = function ($event) {
      _vm.show3 = true
    }
    _vm.e2 = function ($event) {
      _vm.model.inHospital = 0
    }
    _vm.e3 = function ($event) {
      _vm.model.inHospital = 1
    }
    _vm.e4 = function ($event) {
      _vm.model.hurtType = 0
    }
    _vm.e5 = function ($event) {
      _vm.model.hurtType = 1
    }
    _vm.e6 = function ($event) {
      _vm.model.hurtType = 1
    }
    _vm.e7 = function ($event) {
      _vm.model.medicalInsurance = 0
    }
    _vm.e8 = function ($event) {
      _vm.model.medicalInsurance = 1
    }
    _vm.e9 = function ($event) {
      _vm.i--
    }
    _vm.e10 = function ($event) {
      _vm.show1 = false
    }
    _vm.e11 = function ($event) {
      _vm.show2 = false
    }
    _vm.e12 = function ($event) {
      _vm.show3 = false
    }
    _vm.e13 = function ($event) {
      _vm.show4 = false
    }
    _vm.e14 = function ($event) {
      _vm.show5 = false
    }
    _vm.e15 = function ($event) {
      _vm.show6 = false
    }
  }
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        g0: g0,
        g1: g1,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }